import type { BarConfig, RackOptions } from '../../../RackTypes'

export const MAIN_CAVE_GROUP = 'RF0921'
export const MAIN_CAVE_BUNDLE = 'MONSTER-CAVE-2-0-BUNDLE-1'
export const LEFT_CAVE_BUNDLE = 'MONSTER-CAVE-2-0-BUNDLE-2'
export const RIGHT_CAVE_BUNDLE = 'MONSTER-CAVE-2-0-BUNDLE-3'
export const ADDON_CAVE_BUNDLES = ['MONSTER-CAVE-2-0-BUNDLE-2', 'MONSTER-CAVE-2-0-BUNDLE-3']
// The configurable each bundle's main option resolves to; the order PDF and the confirmation email section on these rows.
export const CAVE_RACK_SKU = 'MONSTER-CAVE-2-0-RACK'
export const CAVE_FOLD_RACK_SKU = 'MONSTER-CAVE-2-0-FOLD-RACK'
export const CAVE_PANEL_LEFT_SKU = 'MONSTER-CAVE-2-0-PANEL-LEFT'
export const CAVE_PANEL_RIGHT_SKU = 'MONSTER-CAVE-2-0-PANEL-RIGHT'
export const SIMPLE_CABLE_SYSTEMS = ['RF1121-100-BLACK-MG', 'RF1117-100-BLACK-MG-LH', 'RE0097-100-BLACK-MG'] // RF1121-100-BLACK-MG - LP-2, RF1117-100-BLACK-MG-LH - CT-1 Left Side, RE0097-100-BLACK-MG - CT-1 Right Side
export const CAVE_SKUS = [CAVE_FOLD_RACK_SKU, CAVE_RACK_SKU, MAIN_CAVE_GROUP, MAIN_CAVE_BUNDLE, LEFT_CAVE_BUNDLE, RIGHT_CAVE_BUNDLE]
export const CAVE_OLD_SLINGER_SKU = 'MONSTER-CAVE-2-0-SLINGER'
export const CAVE_SLINGER_X_SKU = 'MONSTER-CAVE-2-0-SLINGER-X'

export const PANEL_ONLY_OFFSET_90 = 10
export const PANEL_ONLY_OFFSET_100 = 20

// Lat Pulldown Attachments only available when Slinger cable system is selected
// These SKUs appear in the Lat Pulldown Attachment row for Slinger only
export const SLINGER_ONLY_LAT_SKUS: readonly string[] = [
  'RA3420-28.5-AL', // Single Handle Cable Attachment - 28.5MM - Raw Aluminum
  'RA3319', // Rogue TR-2D Tricep Dual Cable Attachment
  'RA1726', // Rogue Tricep Strap
  'RA3456-AN-BK', // Rogue Rotating V-Grip Cable Attachment
]

// Lat Pulldown Attachments NOT available when Slinger cable system is selected
// These SKUs appear for LP-2 and CTM-1 but not Slinger
export const NON_SLINGER_LAT_SKUS: readonly string[] = [
  'RA3267', // Rogue CG-1T Triangle Cable & Landmine Attachment
  'RA3317', // Rogue CG-1X X Grip Cable Attachment - Aluminum
  'RA3277', // Rogue CG-1CG Close Grip Cable Attachment
]

export const BAR_CONFIG: BarConfig = {
  barType : 'ohio',
  shaft   : { material: 'powdercoat'},
  knurl   : { material: 'knurl', color: '#555555', config: { mapRepeat: 0.75, metalness: 0.8, roughness: 0.5 } },
  sleeves : { material: 'powdercoat' },
  endcap  : 'ohio',
  bushing : { material: 'custom', color: '#a27e29', config: { metalness: 0.8, roughness: 0.3 } },
  plates  : [{ line: 'hg', weight: '45' }],
}

// All inch values below are estimates.
export const CAVE_RACK_WIDTH = 49 // from outside upright to outside upright

export const CAVE_CABLE_DEPTH: Record<string, number> = {
  'mini feet' : 0,
  'ctm-1'     : 50,
  'ct-1'      : 46.5,
  'lp-2'      : 73,
  'slinger'   : 34,
}

// INDY width + 10" for both uprights and footplates
export const CAVE_INDY_DEPTH: Partial<Record<RackOptions['depth'], number>> = {
  '2' : 34,
  '3' : 40,
  '4' : 53,
}

// Real-world overhang beyond the panel's mass_width (upright + foot plate).
export const CAVE_PANEL_WIDTH_OFFSET = 5

// Additional width (inches) added per side by a cable attachment's footplate/hardware.
export const CAVE_CABLE_WIDTH_OFFSET: Record<string, number> = {
  'ctm-1'   : 7.5,
  'ct-1'    : 2.5,
  'lp-2'    : 11.25,
  'slinger' : 0,
}

// Extra depth (east/west) added by the 14" crossmember and the storage section
export const CAVE_6POST_DEPTH_EXTRA = 17

// Fold-back rack depths — keyed by the rack_depth attribute value (without ").
// Each total includes the nominal fold depth + upright (3") + foot plate (2").
export const CAVE_FOLD_4POST_DEPTH: Record<string, number> = {
  '21.5' : 29.5,
  '41.5' : 49.5,
}

// 6-post fold-back has a single depth option.
// 24" fold depth + 11" crossmember + 3" upright + 2" foot = 40"
export const CAVE_FOLD_6POST_DEPTH = 48


